// extracted by mini-css-extract-plugin
export default {"itemsWrapper":"styles_itemsWrapper__laXPG"};